export class Pax {
    total = 0;
    adults = 0;
    teens = 0;
    children = 0;
    infants = 0;
}
